import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getCurrencySymbol } from '@angular/common';
import { InvoiceService } from 'src/app/services/invoice.service';
import { CurrencyService } from 'src/app/services/currency.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { Subscription } from 'rxjs';
import { OrderService } from 'src/app/services/order.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { GusService } from 'src/app/services/gus.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-prepaid',
  templateUrl: './prepaid.component.html',
  styleUrls: ['./prepaid.component.scss']
})
export class PrepaidComponent implements OnInit, OnDestroy {
  prepaidAmount: number;
  prepaidForm: FormGroup;
  invoiceType;
  selectedInvoiceType;
  selectedCurrency;
  currencySymbol;
  savedInvoiceDetails = [];
  selectedInvoiceDetailsId = 0;
  invoiceDetailsDialogVisible = false;
  gusDialogVisible = false;
  showSummary = false;
  currencySubscription: Subscription;
  gusTaxNumber;
  isNipValid = true;
  specialSelectedCurrency = "PLN";
  gusDataLoading = false;

  public invoiceSelected: any;

  constructor(
    private formBuilder: FormBuilder,
    private invoiceService: InvoiceService,
    private currencyService: CurrencyService,
    private browserStorageService: BrowserStorageService,
    private orderService: OrderService,
    private title: Title,
    private translate: TranslateService
  ) {
    this.prepaidForm = this.formBuilder.group({
      prepaidAmount: ['', Validators.required],
      payment_type: [null, Validators.required],
      currency: ['', Validators.required],
      selectedInvoice: [null, Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.currencySubscription.unsubscribe();
  }

  ngOnInit(): void {
 
    this.getCurrency();
    this.invoiceService.getInvoiceDetails().subscribe(resp => { this.savedInvoiceDetails = resp.data.invoice_details; });

    this.currencySubscription = this.currencyService.
      currencyChangeEmitter.subscribe((name: string) => {
        this.getCurrency();
        this.showSummary = false;
      });
 
    this.orderService.getPrepaidAmount().subscribe(resp => {
      if (resp.success) {
        this.prepaidAmount = resp.data.prepaid_amount;
      }
    });
    this.title.setTitle(this.translate.instant('title_prepiad'));
  }
 
  onSelectPaymentMethod(event) {
    this.prepaidForm.get('payment_type').setValue(event.value.code);
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.browserStorageService.get("_currency");
      this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
      this.prepaidForm.controls['currency'].setValue(this.selectedCurrency);
    }, 100);
  }

  public gotoSummary() {
    this.showSummary = true;
  }
 
  public onGoBack() {
    this.showSummary = false;
  }

  public onOrderAndPay() {
    this.orderService.prepaidPay(this.prepaidForm.value).subscribe({
      next: (response) => {
        window.location.href = response.data;
      }
    });
  }
 

  public changeInvoice(invoice) {
    this.invoiceSelected = invoice;
    this.prepaidForm.controls['selectedInvoice'].setValue(invoice);
  }
}
